import React, { useCallback } from 'react'
import { MultiValue } from 'react-select'
import { EMPTY_ARRAY } from '../../../constants'
import { BasicSelect, BasicSelectProps } from '../BasicSelect/BasicSelect'
import { SelectedOptions } from './SelectedOptions'

export type TagsSelectProps<Option> = Omit<BasicSelectProps<Option, true>, 'isMulti' | 'value'> & {
  value?: MultiValue<Option>
  collapseCount?: number
}

/**
 * Same as multi BasicSelect but with a custom multi value component outside of the select.
 */
export const TagsSelect = <Option extends any>({
  onChange,
  value = EMPTY_ARRAY,
  getOptionValue,
  getOptionLabel,
  collapseCount,
  ...props
}: TagsSelectProps<Option>) => {
  const handleRemove = useCallback(
    (id: string) => {
      if (!onChange) return
      let removedValue: Option
      const newValues = value.filter(v => {
        if (getOptionValue(v) === id) {
          removedValue = v
          return false
        }
        return true
      })
      //@ts-expect-error here for some reason removedValue says that it is used before initialization
      onChange(newValues, { action: 'remove-value', removedValue })
    },
    [getOptionValue, onChange, value],
  )

  return (
    <>
      <BasicSelect
        value={value}
        getOptionLabel={getOptionLabel}
        onChange={onChange}
        getOptionValue={getOptionValue}
        isMulti
        disableTags
        disableSearchClearOnSelect
        {...props}
      />
      <SelectedOptions
        value={value}
        getOptionValue={getOptionValue}
        getOptionLabel={getOptionLabel}
        onRemove={handleRemove}
        collapseCount={collapseCount}
      />
    </>
  )
}
